import { useState, useEffect, useRef, forwardRef, useImperativeHandle } from "react";
import { computePosition, autoPlacement } from '@floating-ui/dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCaretUp, faSearch, faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { Loader } from '../../components/generics/Loader';
import "../../styles/common/drop-down.scss";
import { useDebounce } from "../generics/useDebounce";
import { ReactComponent as MinutesIcon } from "../../Assets/Frame Mins.svg"
import { ReactComponent as HoursIcon } from "../../Assets/Frame H.svg"
import { focusElement } from "../generics/helper"
const MultiSelectDropDown = forwardRef((props, ref) => {
    const { width, listWidth = width, name, label, isCompulsory, options, preSelectedValues = [], searchPlaceholder, disabled, remoteData = false, watch = false, watchIcon = 1 } = props;
    const { nextId, prevId, id } = props
    const defaultValue = Object.assign([], preSelectedValues);
    const [showDrop, setShowDrop] = useState(false);
    const [focus, setFocus] = useState(false);
    const [blur, setBlur] = useState(true);
    const [list, setList] = useState(options);
    const [selectedDisplayValue, setSelectedDisplayValue] = useState('');
    const [selectedValues, setSelectedValues] = useState([]);
    const [searchInput, setSearchInput] = useState("");
    const [remoteSearchInput, setRemoteSearchInput] = useState("");
    const [filteredLists, setFilteredLists] = useState(options);
    const [loading, setLoading] = useState(false);
    const dropRef = useRef(null);
    const dropListRef = useRef(null);
    const searchInputRef = useRef(null);
    const searchResultRef = useRef(null)
    const input1ref = useRef(null)
    const debouncedSearchTerm = useDebounce(remoteSearchInput, 500);
    const [cursor, setCursor] = useState(0)


    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dropRef]);

    useEffect(() => {
        if (showDrop) {
            computePosition(dropRef.current, dropListRef.current, {
                placement: 'bottom-start',
                middleware: [autoPlacement({
                    allowedPlacements: ['top-start', 'bottom-start'],
                })],
            }).then((res) => {
                const { x, y } = res;
                Object.assign(dropListRef.current.style, {
                    left: `${x}px`,
                    top: `${y < 0 ? (y - 10) : y}px`
                })
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showDrop]);

    useEffect(() => {
        const { options } = props;
        setList(options);
        setFilteredLists(options);
        if (defaultValue.length > 0 && options.length > 0) {
            const { isObject, primaryKey } = props
            if (isObject) {
                let selectedItems = [];
                for (let dv of defaultValue) {
                    const selectedItem = options.find((l) => l[primaryKey] === dv[primaryKey]);
                    if (selectedItem) {
                        selectedItems.push(selectedItem);
                    }
                }
                setSelectedValues(selectedItems);
            } else {
                setSelectedValues(defaultValue);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [options]);

    useEffect(() => {
        const { isObject, labelKey } = props;
        if (selectedValues.length > 0) {
            if (isObject) {
                const selectedDisplayValuesArr = selectedValues.map(item => item[labelKey]);
                setSelectedDisplayValue(selectedDisplayValuesArr.join(','));
            } else {
                setSelectedDisplayValue(selectedValues.join(','));
            }
        } else {
            setSelectedDisplayValue('');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedValues])

    useEffect(() => {
        if (showDrop && !disabled) {
            searchInputRef.current.focus()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showDrop])
    useEffect(() => {
        const { remoteData = false } = props;
        if (remoteData) {
            if (debouncedSearchTerm) {
                setLoading(true);
                fetchRemoteData(debouncedSearchTerm).then((options) => {
                    setLoading(false);
                    setFilteredLists(Object.assign([], options));
                });
            } else {
                setFilteredLists([]);
                setLoading(false);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedSearchTerm] // Only call effect if debounced search term changes
    );
    useEffect(() => {
        if (cursor < 0 || cursor > filteredLists.length || !searchResultRef) {
            return () => { }
        }
        if (searchResultRef && searchResultRef.current && searchResultRef.current.children) {
            let listItems = Array.from(searchResultRef.current.children)
            listItems[cursor] && scrollIntoView(listItems[cursor].offsetTop - 40)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cursor])
    const scrollIntoView = (position) => {
        searchResultRef.current.scrollTo({
            top: position,
            behavior: 'smooth',
        })
    }
    const focusNextElement = () => {
        // clickElement(nextId) || focusElement(nextId);
        // clickElement(nextId) || focusElement(nextId);
        focusElement(nextId)
    }
    const focusPrevElement = () => {
        // clickElement(prevId) || focusElement(prevId);
        // clickElement(prevId) || focusElement(prevId);
        focusElement(prevId)
    }
    const hideSuggestion = (e, el) => {
        setShowDrop(false)
    }
    const keyboardNavigation2 = (e) => {
        const { singleSelect } = props;

        if (e.key === 'ArrowDown') {
            showDrop ? setCursor((c) => (c < filteredLists.length - 1 ? c + 1 : 0)) : handleDrop()
        }

        if (e.key === 'ArrowUp') {
            setCursor((c) => (c > 0 ? c - 1 : 0))
        }

        if (e.key === 'Escape') {
            hideSuggestion()
            input1ref.current.focus()
        }
        if (e.key === 'Enter' && cursor > -1) {
            onSelectItem(e, filteredLists[cursor])
            if (singleSelect === true) {
                hideSuggestion()
                nextId ? focusNextElement() : input1ref.current.focus()
            }
        }
    }
    const keyboardNavigation1 = (e) => {
        if (e.key === 'ArrowDown') {
            handleDrop(e)
        }
        if (e.key === 'ArrowUp') {
            handleDrop(e)
        }
        if (e.key === 'Escape') {
            focusPrevElement()
        }
        if (e.key === 'Enter') {
            focusNextElement()
        }
    }
    const fetchRemoteData = async (searchValue) => {
        const { fetchRemoteDataHandler = () => { return [] } } = props;
        let newOptions = await fetchRemoteDataHandler(searchValue);
        return newOptions;
    }

    const handleClickOutside = (e) => {
        if (!(dropRef && dropRef.current && dropRef.current.contains(e.target))) {
            setShowDrop(false);
        }
    };

    const handleDrop = (e) => {
        setSearchInput('');
        setShowDrop(true);
        setFilteredLists(list);
    };

    const onRemoveSelectedItem = (item) => {
        let index = -1;
        const { onRemove, primaryKey, isObject } = props;
        if (isObject) {
            index = selectedValues.findIndex((sv) => sv[primaryKey] === item[primaryKey])
        } else {
            index = selectedValues.indexOf(item);
        }
        if (index >= 0) {
            selectedValues.splice(index, 1);
            if (onRemove)
                onRemove(selectedValues, item);

            setSelectedValues(Object.assign([], selectedValues));
        }
    }

    const onSelectItem = (e, item) => {
        const { onSelect = () => { }, singleSelect } = props;
        e.stopPropagation();
        if (singleSelect) {
            onSingleSelect(item);
            onSelect([item], item);
            return;
        }
        if (isSelectedValue(item)) {
            onRemoveSelectedItem(item);
            return;
        }
        selectedValues.push(item);
        onSelect(selectedValues, item);
        setSelectedValues(Object.assign([], selectedValues));

    }

    const onSingleSelect = (item) => {
        const { isObject, labelKey } = props
        setSelectedValues([item]);
        setSelectedDisplayValue(isObject ? item[labelKey] : item);
        setShowDrop(false);
    }


    const searchItems = (searchValue) => {
        if (remoteData) {
            setRemoteSearchInput(searchValue);
            return;
        }
        setSearchInput(searchValue);
        if (searchValue !== "") {
            const filterData = list.filter((item) => {
                return Object.values(item)
                    .join("")
                    .toLowerCase()
                    .includes(searchValue.toLowerCase());
            });
            setFilteredLists(filterData);
        } else {
            setFilteredLists(Object.assign([], list));
        }
    };

    const clearSearchInput = () => {
        if (searchInputRef.current) {
            searchInputRef.current.value = '';
            searchItems('');
        }
    }

    const resetItem = () => {
        const { onRemove } = props;
        setSelectedDisplayValue("");
        setSelectedValues([]);
        if (onRemove)
            onRemove([]);

    };

    const isSelectedValue = (item) => {
        const { isObject, primaryKey } = props;
        if (isObject) {
            return (selectedValues.filter(i => i[primaryKey] === item[primaryKey]).length > 0);
        }
        return selectedValues.filter(i => i === item).length > 0;
    }

    useImperativeHandle(ref, () => ({
        resetAutocomplete(event) {
            resetItem()
        }
    }));

    const renderOptionList = () => {
        const { loadingMessage = 'Loading...', isObject, style = [], labelKey, primaryKey, noDataLabel = 'No results found' } = props;
        if (loading) {
            return (
                <div className="loading-container">
                    <Loader />
                    {typeof loadingMessage === 'string' && <span style={style['loadingMessage']} className={`not--found`}>{loadingMessage}</span>}
                </div>
            )
        }
        return (
            filteredLists.length > 0 ? (
                filteredLists.map((el, index) => {
                    const isSelected = isSelectedValue(el);
                    const optionKey = isObject ? el[primaryKey] : `${el}-${index}`;
                    const optionLabel = isObject ? el[labelKey] : el;
                    return (
                        <div key={optionKey} className={`drop--item ${isSelected ? "selected" : ""} ${cursor === index ? 'highlighted' : ''}`} onClick={(e) => onSelectItem(e, el)}>
                            <div className={`search--checkbox ${isSelected ? "checked" : ""}`}>
                                {isSelected && (
                                    <span className="check">
                                        <FontAwesomeIcon icon={faCheck} color={"#fff"} />
                                    </span>
                                )}
                            </div>
                            <div>{optionLabel}</div>
                        </div>
                    )
                })
            ) : (
                <div className="not--found">{noDataLabel}</div>
            )
        )
    }

    const labelTxyt =
        isCompulsory ? (
            <span>
                {label}
                <span style={{ color: "red", paddingLeft: "5px" }}>*</span>
            </span>
        ) : (
            label
        );
    return (
        <div className={`dropdown--wrapper ${disabled ? "disable" : ""}`} style={{ width: width }} ref={dropRef} onClick={handleDrop}>
            <input
                ref={input1ref}
                type="text"
                id={id}
                className={`inp--field ${disabled ? "disable" : ""}`}
                onFocus={() => {
                    setFocus(true);
                    setBlur(false);
                }}
                onBlur={() => {
                    setBlur(true);
                    setFocus(false);
                }}
                onKeyDown={keyboardNavigation1}
                value={selectedDisplayValue}
                readOnly
            />
            {!watch &&
                selectedDisplayValue && !disabled && (
                    <div className="cross--icon" onClick={resetItem}>
                        <span className="cross">
                            <FontAwesomeIcon icon={faXmark} color={"#777"} />
                        </span>
                    </div>
                )}
            <div className="caret--icon">
                {!watch ? showDrop ? (
                    <FontAwesomeIcon icon={faCaretUp} color={"#777"} />
                ) : (
                    <FontAwesomeIcon icon={faCaretDown} color={"#777"} />
                ) : watchIcon === 1 ? <HoursIcon style={{ height: "41px", width: "41px", position: 'absolute', top: '-10px', left: '-26px' }} /> : <MinutesIcon style={{ height: "40px", width: "40px", position: 'absolute', top: '-10px', left: '-26px' }} />}
            </div>
            <div className={`inp--label ${focus ? "active" : selectedDisplayValue && blur ? " filled" : ""}`}>
                {labelTxyt}
            </div>
            {showDrop && (
                <div className="drop--wrapper" style={{ width: listWidth }} ref={dropListRef}>
                    <div className="drop--search">
                        <input
                            name={name}
                            type="text"
                            className="search"
                            autoComplete="off"
                            placeholder={searchPlaceholder}
                            onChange={(e) => searchItems(e.target.value)}
                            ref={searchInputRef}
                            onKeyDown={keyboardNavigation2}
                        />
                        <div className="search--icon">
                            <FontAwesomeIcon icon={faSearch} color={"#777"} />
                        </div>
                        {(searchInput || remoteSearchInput) && (
                            <div className="cross--icon" onClick={clearSearchInput}>
                                <span className="cross">
                                    <FontAwesomeIcon icon={faXmark} color={"#777"} />
                                </span>
                            </div>
                        )}
                    </div>
                    <div className="drop--content jc--scroll" ref={searchResultRef}>
                        {renderOptionList()}
                    </div>
                </div>
            )}
        </div>
    );
});


export default MultiSelectDropDown;